import React, { useEffect, useRef, useState } from "react";
import { ConfirmButton } from "../../components/ConfirmButton";
import { notification } from "../../helpers/notification";
import {
    getEventPlaceLocations,
    addEventPlaceLocation,
    updateEventPlaceLocation,
    deleteEventPlaceLocation,
} from "../../services/eventPlaceLocationServices.js";
import { getEventPlaces } from "../../services/eventPlaceServices";

export const LocationList = () => {
    const [locationList, setLocationList] = useState([]);
    const [oldLocationList, setOldLocationList] = useState([]);
    const [open, setOpen] = useState(false);
    const [editUniqueKey, setEditUniqueKey] = useState("");
    const [eventPlaceList, setEventPlaceList] = useState([]);
    let searchInput = useRef(null);
    const [formData, setFormData] = useState({ name: "", placeUniqueKey: "" });
    const [searchValue, setSearchValue] = useState("");

    const onClose = () => {
        setOpen(false);
    };

    const resetForm = () => {
        setFormData({ name: "", placeUniqueKey: "" });
        setEditUniqueKey("");
    };

    const saveForm = (e) => {
        e.preventDefault();
        const form = { ...formData };

        if (!form.name || !form.placeUniqueKey) {
            notification.error({ message: "Lütfen zorunlu alanları doldurunuz." });
            return;
        }

        if (editUniqueKey) {
            form.uniqueKey = editUniqueKey;
            updateEventPlaceLocation(form)
                .then(() => {
                    notification.success({ message: "Kayıt başarıyla güncellendi." });
                    resetForm();
                    setOpen(false);
                    getData();
                })
                .catch(() => {
                    notification.error({ message: "Bir hata oluştu, bilgileri kontrol edip tekrar deneyiniz." });
                });
        } else {
            addEventPlaceLocation(form)
                .then(() => {
                    notification.success({ message: "Kayıt işlemi başarıyla yapıldı." });
                    resetForm();
                    setOpen(false);
                    getData();
                })
                .catch(() => {
                    notification.error({ message: "Bir hata oluştu, bilgileri kontrol edip tekrar deneyiniz" });
                });
        }
    };

    const handleSearch = (value) => {
        setSearchValue(value);
        if (!value) {
            setLocationList(oldLocationList);
            return;
        }
        const search = (key, val) => {
            return key.toLocaleUpperCase().indexOf(val) > -1 || key.toLocaleLowerCase().indexOf(val) > -1;
        };
        setLocationList(oldLocationList.filter((w) => search(w.name, value)));
    };

    const handleReset = () => {
        setSearchValue("");
        setLocationList(oldLocationList);
    };

    const onDeleteConfirm = (uniqueKey) => {
        deleteEventPlaceLocation(uniqueKey)
            .then(() => {
                notification.success({ message: "Kayıt başarıyla silindi." });
                getData();
            })
            .catch(() => {
                notification.error({ message: "Bir hata oluştu tekrar deneyiniz" });
            });
    };

    const showEditPersonnelItem = (uniqueKey) => {
        const item = locationList.find((f) => f.uniqueKey == uniqueKey);
        setFormData({
            name: item.name,
            placeUniqueKey: item.placeUniqueKey,
        });
        setEditUniqueKey(uniqueKey);
        setOpen(true);
    };

    const getData = () => {
        getEventPlaceLocations()
            .then((result) => {
                getEventPlaces()
                    .then((placeResult) => {
                        setEventPlaceList(placeResult.items);
                        setLocationList(result.items);
                        setOldLocationList(result.items);
                    })
                    .catch(() => {});
            })
            .catch(() => {});
    };

    useEffect(() => {
        getData();
    }, []);

    return (
        <>
            <div className="max-w-7xl mx-auto px-4 py-6">
                <div className="flex items-center justify-between mb-6">
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Etkinlik Bölgeleri</h1>
                    <button
                        onClick={() => {
                            resetForm();
                            setOpen(true);
                        }}
                        className="inline-flex items-center gap-2 px-4 py-2 bg-red-500 text-white text-sm font-medium rounded-lg hover:bg-red-600 transition-colors"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                        </svg>
                        Yeni Oluştur
                    </button>
                </div>
                <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700">
                    <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-700">
                        <div className="flex items-center gap-3">
                            <div className="relative flex-1 max-w-xs">
                                <input
                                    ref={searchInput}
                                    type="text"
                                    value={searchValue}
                                    onChange={(e) => handleSearch(e.target.value)}
                                    placeholder="Lokasyon ara..."
                                    className="w-full px-3 py-2 pl-9 border border-gray-300 dark:border-gray-600 rounded-lg text-sm bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none"
                                />
                                <svg className="absolute left-3 top-2.5 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                            </div>
                            {searchValue && (
                                <button
                                    onClick={handleReset}
                                    className="px-3 py-2 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors"
                                >
                                    Temizle
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm text-left">
                            <thead className="text-xs text-gray-500 uppercase bg-gray-50 dark:bg-gray-800">
                                <tr>
                                    <th className="px-4 py-3">Lokasyon Adı</th>
                                    <th className="px-4 py-3">Mekan</th>
                                    <th className="px-4 py-3 text-right">İşlemler</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                                {locationList.map((item) => (
                                    <tr key={item.uniqueKey} className="hover:bg-gray-50 dark:hover:bg-gray-800">
                                        <td className="px-4 py-3 text-gray-900 dark:text-gray-100">{item.name}</td>
                                        <td className="px-4 py-3 text-gray-900 dark:text-gray-100">{item.placeName}</td>
                                        <td className="px-4 py-3 text-right">
                                            <div className="flex items-center justify-end gap-2">
                                                <button
                                                    onClick={() => showEditPersonnelItem(item.uniqueKey)}
                                                    className="inline-flex items-center gap-1 px-3 py-1.5 bg-blue-500 text-white text-xs font-medium rounded-lg hover:bg-blue-600 transition-colors"
                                                >
                                                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                    </svg>
                                                    Düzenle
                                                </button>
                                                <ConfirmButton onConfirm={() => onDeleteConfirm(item.uniqueKey)} message="Silmek istediğinizden emin misiniz?">
                                                    <button
                                                        className="inline-flex items-center gap-1 px-3 py-1.5 bg-red-500 text-white text-xs font-medium rounded-lg hover:bg-red-600 transition-colors"
                                                    >
                                                        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                        </svg>
                                                        Sil
                                                    </button>
                                                </ConfirmButton>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {open && (
                <>
                    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[9998]" onClick={onClose} />
                    <div className="fixed right-0 top-0 h-full w-full max-w-lg bg-white dark:bg-gray-900 z-[9999] shadow-2xl transition-transform">
                        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                                {editUniqueKey ? "Güncelleme" : "Yeni Lokasyon Ekle"}
                            </h3>
                            <button onClick={onClose} className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg text-gray-500">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div className="p-6 overflow-y-auto">
                            <form onSubmit={saveForm} className="space-y-5">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Bölge Adı</label>
                                    <input
                                        type="text"
                                        required
                                        value={formData.name}
                                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                        placeholder="Bölge Adı"
                                        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-sm bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Mekan</label>
                                    <select
                                        required
                                        value={formData.placeUniqueKey}
                                        onChange={(e) => setFormData({ ...formData, placeUniqueKey: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-sm bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none"
                                    >
                                        <option value="">Mekan seçiniz</option>
                                        {eventPlaceList.map((m) => (
                                            <option key={m.uniqueKey} value={m.uniqueKey}>{m.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <button
                                    type="submit"
                                    className="inline-flex items-center gap-2 px-4 py-2 bg-red-500 text-white text-sm font-medium rounded-lg hover:bg-red-600 transition-colors"
                                >
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
                                    </svg>
                                    Kaydet
                                </button>
                            </form>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};
